import React, { useEffect, useState } from "react";
import "./TestimonialSection.css";
import leafBg from '../images/test_leaf.png'; 

// ഇവിടെ നിങ്ങളുടെ ഓരോ കസ്റ്റമേഴ്സിന്റെയും യഥാർത്ഥ ചിത്രങ്ങൾ ഇമ്പോർട്ട് ചെയ്യുക
// (ഉദാഹരണത്തിന് താഴെ നൽകിയിരിക്കുന്നത് പോലെ ചെയ്യാം)
import customerImg1 from '../images/1.png'; 
import customerImg2 from '../images/2.png'; 
import customerImg3 from '../images/3.png'; 
import customerImg4 from '../images/4.png'; 
import customerImg5 from '../images/5.png'; 
import customerImg6 from '../images/6.png'; 
import customerImg7 from '../images/7.png'; 

const testimonials = [
  {
    quote: "A big thank you to team Ayur Moksha for the exceptional care over the last two weeks. The 14-day program was exactly what I needed. The treatments were soothing, the service was seamless, and I felt well-supported throughout the process. It’s a great place to focus on healing after delivery.",
    name: "Ash Wathy",
    subtitle: "Prasava Raksha Journey",
    image: customerImg1 // ഇവിടെ ഓരോരുത്തരുടെയും ഇമേജ് നൽകുക
  },
  {
    quote: "I recently completed an Ayurvedic rejuvenation programme at Ayur Moksha, and it was a very calming and refreshing experience overall. Although the centre is located quite close to the railway, the ambience inside is surprisingly peaceful.Being near the river adds to the sense of calm and makes it easy to disconnect from everyday stress. From the initial consultation, the team took time to understand my needs and explained the treatments clearly. The therapists were professional, attentive, and carried out the therapies with great care. The structured routine, treatments, and diet helped me slow down and focus fully on my health.Some phases of the programme were challenging, but they felt purposeful and well guided.By the end of the programme, I noticed improved energy levels, better sleep, and a greater sense of balance, both physically and mentally. Overall, Ayur Moksha offers an authentic Ayurvedic rejuvenation experience in a serene setting. I would recommend it to anyone looking for a genuine reset for the body and mind.",
    name: "Sujinraj M",
    subtitle: "Local Guide",
    image: customerImg2
  },
  {
    quote: "Revitalised!!Left the place feeling super relaxed and calm. Consulted Dr. Shilpa, therapy by Akshay was really good, and even got to chat with the owner Akshay, very genuine and down to earth person.All the best to the team for the new venture. Definitely recommending this to anyone who needs a proper reset.",
    name: "Rahul P",
    subtitle: "Rejuvenation Therapy",
    image: customerImg3
  },
  {
    quote: "I really loved the beauty of the place and the wonderful hands and hearts of the ladies who took care of me. It was a very unique and nurturing experience for me.I would suggest choosing the therapy that your body truly needs at that particular time, because each therapy serves a different purpose. I took the Diamond Pack, and since it matched what my body needed, I am really happy with the experience.So choose the right package wisely according to your body’s needs. I really enjoyed.",
    name: "Pragathi Priya",
    subtitle: "Riverside Escape",
    image: customerImg4
  },
  {
    quote: "I recently experienced true rejuvenation at Ayur Moksha, where wellness is approached in a deeply holistic and mindful way. The therapies refreshed both my body and mind, leaving me feeling lighter, calmer, and more balanced. The thoughtfully chosen Ayurvedic treatments and the warm, attentive staff added a genuine healing touch to the entire experience. Highly recommended for anyone seeking authentic holistic care. ✨",
    name: "AJAY N V",
    subtitle: "Rejuvenation Therapy",
    image: customerImg5
  },
  {
    quote: "I recently tried the 1-day package at Ayur Mokhsa and had a wonderful experience. I consulted with Dr. Shilpa, who explained the package and treatment in detail. The therapy session was relaxing, and the therapist made me feel very comfortable throughout. Thank you for the excellent service!",
    name: "jipsa chandran",
    subtitle: "Rejuvenation Therapy",
    image: customerImg6
  },
  {
    quote: "I completed my 14-day Prasava Raksha treatment under the care of AYUR MOKSHA, and it was an amazing experience. From the very first day, I felt so comfortable and well taken care of. The therapies were relaxing and really helped my body recover after delivery.My Doctors and Therapists were wonderful — always kind, patient, and skilled in their work. They treated me with so much care and made each session a peaceful experience. I started feeling stronger and more energetic every day.. I'm truly thankful to Dr. Shilpa and her team for helping me through my postnatal journey. Highly recommend this treatment for all new mothers! Also, my thanks to AYUR MOKSHA Managing Director Mr Akshay who asked for daily feedback and helped me in the right way with the treatment.",
    name: "Charutha Kotappadam",
    subtitle: "Rejuvenation Therapy",
    image: customerImg7
  }
];

export default function TestimonialSection() {
  const [index, setIndex] = useState(0);
  const totalSlides = Math.ceil(testimonials.length / 2);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % totalSlides);
    }, 6000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const firstCard = testimonials[index * 2] || testimonials[0];
  const secondCard = testimonials[(index * 2) + 1] || testimonials[0]; 

  return (
    <section className="testimonial-section-fluid py-5">
      <div className="leaf-background-overlay" style={{ backgroundImage: `url(${leafBg})` }}></div>

      <div className="container position-relative" style={{ zIndex: 2 }}>
        
        <div className="text-center mb-5">
          <h2 className="main-client-title">
            <span className="script-font-what">What</span> Our Client Say
          </h2>
        </div>

        <div className="row justify-content-center">
          
          {/* Card 1 */}
          <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
            <div className="image-style-card-wrapper">
              
              <div className="customer-profile-frame">
                <div className="svg-arch-container">
                  <svg viewBox="0 0 220 70" width="100%" height="70" style={{ overflow: 'visible' }}>
                    <path id="archPath1" d="M 20,62 A 92,92 0 0,1 200,62" fill="none" />
                    <text fill="#436a3d" className="arch-text">
                      <textPath href="#archPath1" startOffset="50%" textAnchor="middle">
                        Happy Customer
                      </textPath>
                    </text>
                  </svg>
                </div>
                <div className="profile-circle-img">
                  <img src={firstCard.image} alt={firstCard.name} />
                </div>
              </div>

              <div className="exact-yellow-card">
                <p className="card-testimonial-speech">{firstCard.quote}</p>
                <h6 className="card-customer-name">{firstCard.name}</h6>
                <div className="card-stars-plate">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 d-flex justify-content-center">
            <div className="image-style-card-wrapper">
              
              <div className="customer-profile-frame">
                <div className="svg-arch-container">
                  <svg viewBox="0 0 220 70" width="100%" height="70" style={{ overflow: 'visible' }}>
                    <path id="archPath2" d="M 20,62 A 92,92 0 0,1 200,62" fill="none" />
                    <text fill="#436a3d" className="arch-text">
                      <textPath href="#archPath2" startOffset="50%" textAnchor="middle">
                        Happy Customer
                      </textPath>
                    </text>
                  </svg>
                </div>
                <div className="profile-circle-img">
                  <img src={secondCard.image} alt={secondCard.name} />
                </div>
              </div>

              <div className="exact-yellow-card">
                <p className="card-testimonial-speech">{secondCard.quote}</p>
                <h6 className="card-customer-name">{secondCard.name}</h6>
                <div className="card-stars-plate">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="row mt-5">
          <div className="col-12 text-center">
            <div className="custom-slider-dots">
              {[...Array(totalSlides)].map((_, i) => (
                <span
                  key={i}
                  className={i === index ? "slider-dot active" : "slider-dot"}
                  onClick={() => setIndex(i)}
                ></span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}